import {VAutocomplete} from 'vuetify/lib'
export default {
  name: 'base-autocomplete',
  extends: VAutocomplete,
  methods: {
    blur() {
      setTimeout(this.handleBlur, 0)
    },
    handleBlur() {
      this.isMenuActive = false
      this.isFocused = false
      this.selectedIndex = -1
    },
    handleTabDown(e) {
      if (this.isMenuActive) {
        VAutocomplete.options.methods.onTabDown.call(this, e)
      } else {
        this.handleBlur()
      }
    },
  },
}
